const initialState = {
  snackbar: {
    open: false,
    message: ''
  }
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case 'SET_SNACKBAR_MESSAGE':
      return {
        ...state,
        snackbar: payload
      }
    default:
      return state
  }
}
